import { render, staticRenderFns } from "./MatchSignupInfoSection.vue?vue&type=template&id=62d9d366&scoped=true"
import script from "./MatchSignupInfoSection.vue?vue&type=script&lang=js"
export * from "./MatchSignupInfoSection.vue?vue&type=script&lang=js"
import style0 from "./MatchSignupInfoSection.vue?vue&type=style&index=0&id=62d9d366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d9d366",
  null
  
)

export default component.exports